import { IButtonStyles, ITextFieldStyles, PrimaryButton } from 'office-ui-fabric-react';
import * as React from 'react';

import {
  createImmutableList,
  createImmutableMap,
  createStructuredSelector,
  mconnect
} from '../../state/redux';
import { IStyledComponent, styledComponent } from '../../theme';
import { IComponentStateProps, IConnectedComponentProps, IInputNodeStyles } from '../../types';
import { getInputNodeStyles } from '../intentGraph.styles';
import {
  buttonTextSelector,
  diagnosticsFormSelector,
  getNodeSelector,
  isDiagnosticActionInProgressSelector,
  sessionIdSelector
} from '../reducers/selectors.redux';
import { TextField } from './common/FormFields';
import { diapatchInputTextUpdateAction, dispatchPushTargetNodeFromCondition } from '../reducers/dispatchers';
import { updateGlobalVarsAction, updateInputFormFieldsAction } from '../reducers/actions';
import { truncateWithEllipsis } from '../../utils';
import { ErrorType } from '../../models';
import { isFormFieldInvalid } from '../../utils/safDiagnosticSchema';

const mapStateToProps = createStructuredSelector({
  node: getNodeSelector,
  isDiagnosticsInProgress: isDiagnosticActionInProgressSelector,
  diagnosticsForm: diagnosticsFormSelector,
  sessionId: sessionIdSelector,
  buttonText: buttonTextSelector
});

const mapDispatchToProps = {
  diapatchInputTextUpdateAction,
  dispatchPushTargetNodeFromCondition,
  updateGlobalVarsAction,
  updateInputFormFieldsAction
};

type IInputNodeProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  IStyledComponent<IInputNodeStyles> &
  IConnectedComponentProps &
  IComponentStateProps;

class InputNodeC extends React.PureComponent<IInputNodeProps> {
  public render = (): React.ReactNode => {
    if(!this.props.node.get('InputFormField')){
      return null;
    }
    const inputNodeStyles = getInputNodeStyles({ theme: this.props.theme, stylesFunc: this.props.stylesFunc });
    const btnStyles = inputNodeStyles.button || {} as IButtonStyles;
    const textFieldStyles = inputNodeStyles.textField || {} as ITextFieldStyles;
    return (
      <>
        <TextField
          styles={textFieldStyles}
          stylesFunc={this.props.stylesFunc}
          callbackHandlers={this.props.callbackHandlers}
          componentModel={this.props.node.get('InputFormField')}
          onChangeReducer={this.onChange}
        />
        <div>
          <PrimaryButton
            styles={btnStyles}
            title={this.props.buttonText}
            text={truncateWithEllipsis(this.props.buttonText, 62)}
            primary={true}
            disabled={this.isBtnDisabled()}
            onClick={this.onSubmit}
          />
        </div>
      </>
    );
  };

  private isBtnDisabled = () => {
    if(this.props.node.get('InputFormField')){
      return isFormFieldInvalid(this.props.node.get('InputFormField'), ErrorType.None) !== ErrorType.None;
    }
    return true
  };

  private onSubmit = () => {
    if (!!this.props.callbackHandlers.LogHandler) {
      this.props.dispatchPushTargetNodeFromCondition(
        this.props.node,
        this.props.callbackHandlers.LogHandler,
        this.props.callbackHandlers.IsUserSignedIn
      );
    }
  };

  private onChange = (_componentKey: string, text: string) => {
    this.props.diapatchInputTextUpdateAction(text, this.props.node.get('uId'));
    const globalVar = createImmutableMap({
      name: this.props.node.get('variableToSet'),
      value: text
    });
    this.props.updateGlobalVarsAction(createImmutableList([globalVar]));
  };
}

export const InputNode = mconnect(
  mapStateToProps,
  mapDispatchToProps
)(styledComponent(InputNodeC, getInputNodeStyles));
